export default __webpack_public_path__ + "static/media/in-progress.7e651ef8.svg";